import { labels } from "./labels"

const CAR_TYPE = {
    BOX: "BOX",
    HOPPER: "HOPPER",
    GONDOLA: "GONDOLA",
    FLAT: "FLAT",
    INTERMODAL: "INTERMODAL",
    REFRIGERATOR: "REFRIGERATOR",
    STACK: "STACK",
    TANK: "TANK",
}

const INVENTORY_DATE_RANGE_PICKER_TYPES = {
    ETA: "ETA",
    ETI: "ETI",
    EVENT_DATE: "EVENT_DATE",
    SHIPPED_DATE: "SHIPPED_DATE",
    LAST_MOVEMENT: "LAST_MOVEMENT",
}

const LOAD_STATUS_CODE = {
    L: "L",
    E: "E",
    LL: "LL",
    EE: "EE",
    LE: "LE",
}
const SHIPPER_FIELD_VALUE_TYPE = {
    ACTIVITY_INDICATOR: {
        type: "ActivityIndicator",
        label: labels.visibilityFilterOptions["ACTIVITY_INDICATOR"].label,
        value: 1,
    },
    CARRIER: {
        type: "Carrier",
        label: labels.visibilityFilterOptions["CARRIER"].label,
        value: 2,
    },
    CAR_TYPE: {
        type: "CarType",
        label: labels.visibilityFilterOptions["CAR_TYPES"].label,
        value: 3,
    },
    EQUIP_KIND: {
        type: "CarKind",
        label: labels.visibilityFilterOptions["EQUIP_KIND"].label,
        value: 19,
    },
    COMMODITY_DESCRIPTION: {
        type: "CommodityDescription",
        label: labels.visibilityFilterOptions["COMMODITY"].label,
        value: 4,
    },
    CONSIGNEE: {
        type: "Consignee",
        label: labels.visibilityFilterOptions["CONSIGNEE"].label,
        value: 5,
    },
    DESTINATION: {
        type: "DestinationCityState",
        label: labels.visibilityFilterOptions["DESTINATION"].label,
        value: 6,
    },
    ETA: {
        type: "ETA",
        label: labels.visibilityFilterOptions["ETA"].label,
        value: 7,
    },
    ETI: {
        type: "ETI",
        label: labels.visibilityFilterOptions["ETI"].label,
        value: 7,
    },
    EVENT_CITY_STATE: {
        type: "EventCityState",
        label: labels.visibilityColumns["EVENT_CITY_STATE"].label,
        value: 8,
    },
    EVENT_CODE: {
        type: "EventCode",
        label: labels.visibilityFilterOptions["EVENT_CODES"].label,
        value: 9,
    },
    EVENT_DATE: {
        type: "EventDate",
        label: labels.visibilityFilterOptions["EVENT_DATES"].label,
        value: 10,
    },
    EVENT_DESCRIPTION: {
        type: "EventDescription",
        label: labels.wayBillInformationLbl.Description,
        value: 11,
    },
    LOAD_LIMIT: {
        type: "LoadLimit",
        label: labels.visibilityFilterOptions["LOAD_LIMIT"].label,
        value: 12,
    },
    ORIGIN: {
        type: "OriginCityState",
        label: labels.visibilityFilterOptions["ORIGIN"].label,
        value: 13,
    },
    EQUIP_ID: {
        type: "Railcar",
        label: labels.visibilityFilterOptions["EQUIP_ID"].label,
        value: 14,
    },
    SHIPPED_DATE: {
        type: "ShippedDate",
        label: labels.visibilityFilterOptions["SHIPPED_DATE"].label,
        value: 15,
    },
    SHIPPER: {
        type: "Shipper",
        label: labels.visibilityFilterOptions["SHIPPER"].label,
        value: 16,
    },
    TOTAL_WEIGHT: {
        type: "TotalWeightOnRail",
        label: labels.visibilityFilterOptions["TOTAL_WEIGHT"].label,
        value: 17,
    },
    CAR_KIND: {
        type: "CarKind",
        label: labels.visibilityFilterOptions["CAR_KIND"].label,
        value: 19,
    },
    STCC: {
        type: "Stcc",
        label: labels.visibilityFilterOptions["STCC"].label,
        value: 20,
    },
    HAZARDOUS: {
        // Hard coded filter types , not getting the value from API
        type: "IsHazadrous",
        label: labels.visibilityFilterOptions["HAZARDOUS"].label,
    },
    BAD_ORDER: {
        type: "IsBadOrdered",
        label: labels.visibilityFilterOptions["BAD_ORDER"].label,
    },
    LOAD_STATUS: {
        type: "LoadEmptyStatus",
        label: labels.visibilityFilterOptions["LOAD_STATUS"].label,
    },
    UNIT_CAR: {
        type: "OnUnitTrain",
        label: labels.visibilityFilterOptions["UNIT_CAR"].label,
    },
    STORAGE: {
        type: "InStorage",
        label: labels.visibilityFilterOptions["STORAGE"].label,
    },
    OVER_WEIGHT: {
        type: "OverweightStatus",
        label: labels.visibilityFilterOptions["OVER_WEIGHT"].label,
    },
    ONHOLD: {
        type: "OnHold",
        label: labels.visibilityFilterOptions["ONHOLD"].label,
    },
    PLACEMENT_STATUS: {
        type: "PlacementStatus",
        label: labels.visibilityFilterOptions["PLACEMENT_STATUS"].label,
    },
    BILLED: {
        type: "ShipmentType",
        label: labels.visibilityFilterOptions["BILLED"].label,
    },
    WITH_COMMENT: {
        type: "HasComment",
        label: labels.visibilityFilterOptions["WITH_COMMENTS"].label,
    },
    PLACEMENT_AVAILABLE: {
        type: "AvailableForPlacement",
        label: labels.visibilityFilterOptions["PLACEMENT_AVAILABLE"].label,
    },
    EVENT_ROAD: {
        type: "EventRoad",
        label: labels.visibilityFilterOptions["EVENT_ROAD"].label,
        value: 21,
    },
    RAILROAD_DWELL_TIME: {
        type: "EventDate",
        label: labels.visibilityFilterOptions["RAILROAD_DWELL_TIME"].label,
    },
    SHIPPER_DWELL_TIME: {
        type: "ActualPlacementDate",
        label: labels.visibilityFilterOptions["SHIPPER_DWELL_TIME"].label,
    },
    BLOCK_TO: {
        type: "BlockTo",
        label: labels.visibilityFilterOptions["BLOCK_TO"].label,
        value: 24,
    },
    NO_ETA: {
        type: "ETA",
        label: labels.visibilityFilterOptions["NO_ETA"].label,
    },
    EXCEPTION: {
        type: "Exception",
        label: labels.visibilityFilterOptions["EXCEPTION"].label,
    },
}

const SHIPMENT_TYPES = {
    Inbound: 1,
    Online: 2,
    OnHand: 3,
    OutboundBilled: 4,
    OutboundNotBilled: 5,
}
const PLACMENT_STATUS_VALUES = {
    ACTUALLY_PLACED: {
        label: labels.visibilityLbl.actuallyPlaced,
        value: 1,
    },
    CONSTRUCTIVELY_PLACED: {
        label: labels.visibilityLbl.constructivelyPlaced,
        value: 2,
    },
    RELEASED: {
        label: labels.visibilityLbl.released,
        value: 3,
    },
}
const VISIBILITY_SEARCH_TYPES = {
    EQUIPMENT_ID: { key: "EQUIPMENT_ID", val: "Equipment ID" },
    EBOL_NUMBER: { key: "EBOL_NUMBER", val: "BOL Number" },
}

const REQUEST_PREFERENCE = [
    "oldestEquipment",
    "newestEquipment",
    "largestBlock",
    "easiestAvailable",
]

const FAQ_RELEASE_NOTE = {
    FAQ: "FAQ",
    RELEASE_NOTE: "RELEASE_NOTE",
    RVP: "RVP",
}
// Rail roads which has chatbot
const RAIL_ROADS = ["FXE", "FXE2", "FXE5", "FSRR", "FSR5", "FXE8"]

const PRODUCT_GROUPS = [
    "Apparel",
    "Chemicals",
    "Coal",
    "Concrete/Clay",
    "Crude Petroleum",
    "Express Mail",
    "Farm Products",
    "Fish Products",
    "Food Products",
    "Forest Products",
    "Freight Forward",
    "Furniture",
    "Hazardous",
    "Hazardous Waste",
    "Instruments",
    "INTERMODAL",
    "Leather",
    "Lumber or Wood",
    "Machinery",
    "Metal Products",
    "Metals",
    "Minerals",
    "Miscellaneous",
    "Msc Manufacture",
    "Mty Containers",
    "Ordnance",
    "Ore",
    "Petroleum Prods",
    "Plastic/Rubber",
    "Printed Matter",
    "Pulp or Paper",
    "Textiles",
    "Tobacco",
    "Trans Equipment",
    "Waste Materials",
]

const REJECT_REASON_SPANISH_TRANSLATIONS = {
    OV: {
        ReasonCode: "OV",
        ReasonDescription: "sobrecargado",
    },
    AD: {
        ReasonCode: "AD",
        ReasonDescription: "Daños por Accidente",
    },
    BA: {
        ReasonCode: "BA",
        ReasonDescription: "Bolsas de Aire Dañadas",
    },
    FR: {
        ReasonCode: "FR",
        ReasonDescription: "Piso Dañado",
    },
    HH: {
        ReasonCode: "HH",
        ReasonDescription:
            "Sostenedor de Mano Dañado, Escalera, Escalón, Estribo",
    },
    HB: {
        ReasonCode: "HB",
        ReasonDescription: "Freno de Mano Dañado",
    },
    DV: {
        ReasonCode: "DV",
        ReasonDescription: "Divisor de Carga Defectuosa ó Equipo Especial",
    },
    BV: {
        ReasonCode: "BV",
        ReasonDescription: "Válvulas/Tuberías en Mal Estado",
    },
    BW: {
        ReasonCode: "BW",
        ReasonDescription: "Mal Orden de Muros",
    },
    BG: {
        ReasonCode: "BG",
        ReasonDescription: "Rodamientos",
    },
    CN: {
        ReasonCode: "CN",
        ReasonDescription: "Carro No Ordenado",
    },
    LK: {
        ReasonCode: "LK",
        ReasonDescription: "Contenido con Fuga",
    },
    SU: {
        ReasonCode: "SU",
        ReasonDescription: "Superestructura Dañada, cabo/techo/lados",
    },
    BD: {
        ReasonCode: "BD",
        ReasonDescription: "Humedades/Humedo",
    },
    DD: {
        ReasonCode: "DD",
        ReasonDescription: "Puertas Defectuosas, Tolva/Caja Rota",
    },
    BL: {
        ReasonCode: "BL",
        ReasonDescription: "Divisores de Carga Defectuosos",
    },
    RF: {
        ReasonCode: "RF",
        ReasonDescription: "Refrigeración Mecánica Defectuosa",
    },
    OG: {
        ReasonCode: "OG",
        ReasonDescription: "Puerta de Salida Defectuosa",
    },
    RH: {
        ReasonCode: "RH",
        ReasonDescription: "Escotilla/Puerta de Techo Defectuosa",
    },
    DS: {
        ReasonCode: "DS",
        ReasonDescription: "Dispositivos de Seguridad Defectuosos",
    },
    DR: {
        ReasonCode: "DR",
        ReasonDescription: "Sucio",
    },
    FD: {
        ReasonCode: "FD",
        ReasonDescription: "Reclamo por Daño de Carga",
    },
    HX: {
        ReasonCode: "HX",
        ReasonDescription: "Caja de Grasa Caliente",
    },
    BO: {
        ReasonCode: "BO",
        ReasonDescription: "No se puede cargar un carro cargado",
    },
    ZZ: {
        ReasonCode: "ZZ",
        ReasonDescription: "Misceláneos",
    },
    BC: {
        ReasonCode: "BC",
        ReasonDescription: "Sin Cadenas",
    },
    ER: {
        ReasonCode: "ER",
        ReasonDescription: "Detectado por Error",
    },
    CW: {
        ReasonCode: "CW",
        ReasonDescription: "Tipo de Vagón Equivocado",
    },
    CR: {
        ReasonCode: "CR",
        ReasonDescription: "Destinatario Equivocado",
    },
}

const URLS = {
    DASHBOARD: "/",
    LAUNCH: "/launch",
    EMAIL_NOTIFICATIONS: "/email-notifications",
    PLANNING: "/planning",
    REVIEW_PLAN: "/review-plan",
    MANAGEMENT: "/management",
    CALENDAR_VIEW: "/calendar-view",
    DISCARD: "/discard",
    CAR_ORDER: "/car-order",
    CREATE_CAR_ORDER: "/car-order/new-order/order-daily-quality",
    CAR_ORDER_NEW: "/car-order/new-order/select-pattern",
    INVENTORY: "/inventory",
    VISIBILITY_LAZY: "/inventory/:widget_type/:link",
    CHARGE_MANAGEMENT: "/chargeManagement",
    CHARGE_MANAGEMENT_DETAILS: "/chargeManagementDetails",
    GENERAL_PLACEMENT: "/general-placement",
    GENERAL_PLACEMENT_NEW_REQUEST: "/general-placement-new-request",
    SWITCH_REQUEST_LAZY: "/switch-requests",
    SWITCH_REQUEST_NEW_REQUEST: "/switch-requests/new-request",
    ERROR: "/error",
}

const ORDER_OF_LINKS_TO_SHOW_IN_FOOTER = [
    "termsOfUse",
    "privacyPolicy",
    "cookies",
    "yourPrivacyChoices",
    "scamsOrSuspiciousActivity",
    "vulnerabilityReporting",
    "productCybersecurity",
]
const PUBLIC_VIEWS_MAX_LIMIT = 10
export {
    INVENTORY_DATE_RANGE_PICKER_TYPES,
    LOAD_STATUS_CODE,
    CAR_TYPE,
    SHIPPER_FIELD_VALUE_TYPE,
    SHIPMENT_TYPES,
    PLACMENT_STATUS_VALUES,
    VISIBILITY_SEARCH_TYPES,
    REQUEST_PREFERENCE,
    RAIL_ROADS,
    FAQ_RELEASE_NOTE,
    PRODUCT_GROUPS,
    REJECT_REASON_SPANISH_TRANSLATIONS,
    URLS,
    ORDER_OF_LINKS_TO_SHOW_IN_FOOTER,
    PUBLIC_VIEWS_MAX_LIMIT,
}
